export default __webpack_public_path__ + "static/media/save_icon.f498ee25.svg";